import { render, staticRenderFns } from "./toptovarov.vue?vue&type=template&id=feb80c8e&"
import script from "./toptovarov.vue?vue&type=script&lang=js&"
export * from "./toptovarov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports